import { Endpoint } from '@/types/api.type.ts';

export const authEndpoints: Endpoint[] = [
    {
        name: 'register',
        method: 'post',
        path: '/register',
    },
    {
        name: 'registerToken',
        method: 'post',
        path: '/register/token',
    },
    {
        name: 'login',
        method: 'post',
        path: '/login',
    },
    // {
    //     name: 'logout',
    //     method: 'post',
    //     path: '/logout',
    // },
    {
        name: 'getCurrentUser',
        method: 'get',
        path: '/user',
    },
];
